module.exports = __webpack_public_path__ + "static/media/chargermark.e553115b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chargermark.png
// module id = 763
// module chunks = 0